export const GET_FNF_DISMISSAL_DATE = 'GET_FNF_DISMISSAL_DATE';
export const GET_FNF_DATA = 'GET_FNF_DATA';
export const GET_FNF_HRIS_FIELDS = 'GET_FNF_HRIS_FIELDS';
export const UPDATE_FNF_DATA = 'UPDATE_FNF_DATA';
export const GET_NET_PAY_LIST_DATA = 'GET_NET_PAY_LIST_DATA';
export const GET_NET_PAY_LIST_ITEM = 'GET_NET_PAY_LIST_ITEM';
